// extracted by mini-css-extract-plugin
module.exports = {"scrollableWrapper":"TemplateEditingPage_scrollableWrapper__2xGlP","templateEditor":"TemplateEditingPage_templateEditor__2qorX"};